import { useState } from 'react';

export function useModal<T>() {
  const [open, setOpen] = useState<boolean>(false);
  const [dataSelected, setData] = useState<T>();

  const handleToggleModal = (value?: T) => {
    setOpen((o) => !o);
    setData(value);
  };

  const toggleModal = () => {
    setOpen((o) => !o);
  };

  return { open, dataSelected, handleToggleModal, toggleModal };
}
